<div class="flex content-center justify-between h-16 bg-white p-4 font-body font-bold">
  <a href="/" class="w-40">
    <svg viewBox="0 0 541.21 120.93" class="fill-primary-500">
      <g>
        <path
          d="M535.41,59.44a5.93,5.93,0,1,1,5.93-5.93A5.94,5.94,0,0,1,535.41,59.44Zm0-11.11a5.18,5.18,0,1,0,5.18,5.18A5.2,5.2,0,0,0,535.41,48.33Z"
          transform="translate(-0.13 0)"
        />
        <path
          d="M538.26,56.35a12,12,0,0,1-1.84-2.59.29.29,0,0,1-.07-.26,1.86,1.86,0,0,0,1.24-1.61c0-1.49-1.31-1.71-2.32-1.71s-1.65,0-2.56.07a.19.19,0,0,0,0,.31l.25,0c.59.07.59.24.59,1.29h0v3.19c0,1.07,0,1.25-.59,1.34l-.25,0a.22.22,0,0,0,0,.32c.42,0,.84,0,1.35,0s.9,0,1.34,0a.2.2,0,0,0,0-.32l-.34,0c-.5,0-.57-.24-.57-1.34v-1c0-.19,0-.22.42-.22a.61.61,0,0,1,.53.19c.32.46.69,1.17.93,1.51.66.94,1.06,1.24,2,1.24a2.51,2.51,0,0,0,.51-.05.15.15,0,0,0,0-.2A.83.83,0,0,1,538.26,56.35Zm-3.09-2.89c-.59,0-.66,0-.66-.36h0V51c0-.31,0-.39.61-.39a1.35,1.35,0,0,1,1.4,1.37A1.26,1.26,0,0,1,535.17,53.46Z"
          transform="translate(-0.13 0)"
        />
        <path
          d="M502.18,56.64c-.07-9,18.64-10.43,23.75,5L526,44.73c-10.44.53-30.67-4.6-35.24,13.91-2.23,9,6.15,15.62,16.82,18.92,22.46,5.13,20.76,33.6-2.52,35.25-10.85.77-16.53-6.07-15.6-15.5,1.17-13,18-9.61,15.6,3.13a19.81,19.81,0,0,1,13-5.6c-2.26-22.48-36.6-19.69-35,3.94,1.59,24.11,39.76,24.78,47.87,6.73C548.56,66.11,504,72.12,502.18,56.64Z"
          transform="translate(-0.13 0)"
        />
        <path
          d="M485,80.4c-11.49,13-35,7.24-31.13-12.26h33.3c-.21-32.72-46.84-30-46.38,2.53.14,22.82,29.29,31.69,44.21,15.68ZM463.65,49.28c7,.29,9,6.54,9.27,13.79H453.81C454,55.52,457.2,49,463.65,49.28Z"
          transform="translate(-0.13 0)"
        />
        <path
          d="M413,85.78c-5-5,13.06-8.28,16.64-10.08,17.29-8.59,10.72-30.59-7.2-30.83a127.65,127.65,0,0,1,21.28-4.66,17.6,17.6,0,0,1-2.05-7.06c-13,6.6-29.12,9.26-39.49,16.54-12.34,9.25-6.64,26.61,9.18,28.43-4.94,3.84-14.31,4.29-14.55,10.55,0,3.4,2.76,6,8,7.31L404.74,97c-5.33,1.47-9.44,6.65-9.26,10.55.52,19.13,48.59,18,48.59-5.31C444.08,84.19,415.93,88.35,413,85.78ZM408.84,62c.08-17.51,17.15-17.51,17.24,0C426,79.53,408.92,79.53,408.84,62Zm10.33,54.83c-14.44,0-20.17-15.57-7.5-18.69C434.85,93.65,441.15,116.35,419.17,116.85Z"
          transform="translate(-0.13 0)"
        />
        <path
          d="M392.72,80.45c1-38,.86-37.25-37.46-35.42V57.68c17.21-20.57,33.52-.53,18.12,5.83-9,3.43-21.07,5.38-21,18.25,0,14.41,19.56,16.88,28,6.7a8.52,8.52,0,0,0,1.59,4.66H396C392.13,89.47,393,84.81,392.72,80.45Zm-12.37-3.54c-1.07,23.53-35.57,2.87,0-11.43Z"
          transform="translate(-0.13 0)"
        />
        <path
          d="M348.22,17.33A80.71,80.71,0,0,1,333,22h0c6.11,4.27,4.94,63.74.82,70.85l17.78.06C347.93,92.09,347.93,52.77,348.22,17.33Z"
          transform="translate(-0.13 0)"
        />
        <path
          d="M327.53,17.33a60.44,60.44,0,0,1-7.86,2.83c1-3.84,9.32-7.49,14.08-8.91-3-7.66-10.26-12-21.81-11.14C281.39,4.18,268.79,54,260,78.39c-.11-4.88-23.49-50.12-14.49-52.76-10.93,1.11-21.81-1.35-35.61-2.56-16.54-1.46-29.07,8.26-29,24.67,2.12,40.7,60.43,20.65,40.59-9.32a36.53,36.53,0,0,1-15,7.6c7.91,10.24,4.73,17.94-4.28,18.92-7.74.5-14.37-5.83-14.89-17.21-.18-12.2,7.08-18.95,18.29-21,6.8-1.27,20.94.17,23.1,6.72,3.34,8.53,15.1,38.34,21,54.6.45,1.28-.13,2.46-1.17,4.89H263c3.87-20.92,25.1-83.11,46.91-82.52,5.25.19,6.17,6.88,6.31,10.74-1.25.32-2.54.63-3.86.93h0c6.11,4.25,4.94,63.76.82,70.85l17.78.06C327.24,92.09,327.24,52.77,327.53,17.33Z"
          transform="translate(-0.13 0)"
        />
        <path
          d="M308.18,30.41c.1-10.32-15.95-10.31-15.83,0C292.23,40.7,308.29,40.72,308.18,30.41Z"
          transform="translate(-0.13 0)"
        />
        <path
          d="M307.24,44.44c-5.16,2.06-10,3.77-15.36,4.24,5.46,3.3,6.27,39.55.12,44.27h17.82C306.19,76.57,308.88,60.35,307.24,44.44Z"
          transform="translate(-0.13 0)"
        />
        <path
          d="M175.9,69.55c-.21-32.72-46.84-30-46.38,2.53.14,22.82,29.27,31.7,44.2,15.68v-6c-11.49,13-35,7.24-31.12-12.26ZM152.39,50.69c7,.29,9,6.54,9.26,13.79H142.54C142.71,56.93,145.94,50.45,152.39,50.69Z"
          transform="translate(-0.13 0)"
        />
        <path
          d="M129.76,110c-8.43-1.13-3.09-21.24-3.09-53.24-.3-7.4-5.86-11.45-12.68-11.66-8,0-12,2.47-16.3,7.07-.82.94-.71-.12-.7-.59V18.54c-4.88,2.17-11,3.24-15.61,4.31L81.79,24c-21,6.65-37.49-6.37-59.65-6.11C-6.67,19.22-7.3,64,20.83,64.46,39.18,64.28,47.45,52,42.11,36.93A36.76,36.76,0,0,1,26.4,42.12c4.28,10,3,16.88-6,17.21C-7.33,59.56.67,1.56,51.48,33.1c-1,7.75,3,55.66-3.81,61H68.49c-1.94-3-2.23-6-3.4-9-.18-17.16-.47-34.66-.82-51.58,22.34-2.23,19.92-5.12,20.46-2.24a386.34,386.34,0,0,1-.88,62.43H99.51c-1.94-9.08-7-40.08,6-41.68,4.07-.5,7.86,3.13,8.5,8.14.59,13.91-1.54,27.84-.82,41.73,1.16,22.67,37.39,16.22,33.18-4.77L134,100.59C135.86,106.13,135.68,110.61,129.76,110Z"
          transform="translate(-0.13 0)"
        />
      </g>
    </svg>
  </a>

  <button
    class="flex flex-col items-center text-xs text-primary-500 cursor-pointer"
    (click)="showMenu.set(true)"
  >
    <svg viewBox="0 0 640 640" class="fill-primary-500">
      <path
        d="M96 160C96 142.3 110.3 128 128 128L512 128C529.7 128 544 142.3 544 160C544 177.7 529.7 192 512 192L128 192C110.3 192 96 177.7 96 160zM96 320C96 302.3 110.3 288 128 288L512 288C529.7 288 544 302.3 544 320C544 337.7 529.7 352 512 352L128 352C110.3 352 96 337.7 96 320zM544 480C544 497.7 529.7 512 512 512L128 512C110.3 512 96 497.7 96 480C96 462.3 110.3 448 128 448L512 448C529.7 448 544 462.3 544 480z"
      />
    </svg>

    MENU
  </button>
</div>

<app-side-menu
  [menuItems]="menuItems()"
  [temperature]="temperature()"
  [(showMenu)]="showMenu"
  (openMyVillagesClicked)="openMyVillages()"
  [class]="
    'block absolute top-0 left-0 h-full bg-black/80 z-10 overflow-hidden transition-opacity ease-in-out ' +
    (showMenu() ? 'w-full opacity-100' : 'w-0 opacity-0')
  "
/>
